import { Box, TextField, Typography } from '@mui/material';
import { Component, createRef } from 'react';
import AppManager from '../../commun/AppManager';
import { Spinner } from '../../commun/component/Spinner';
import { post } from '../../commun/HTTP';
import { PerfectAJOList } from '../../commun/object/PerfectAJOList';
import Result from '../../commun/Result';
import Toast from '../../commun/toast/Toast';
import BasePrice from '../../object/BasePrice';
import Prestation from '../../object/profile/Prestation';
import { JSXInternal } from 'preact/src/jsx';
import Category from '../../object/tag/Category';
import { getErrorMessage } from '../../utils/Error';
import { SelectCategoryList } from '../category/SelectCategoryList';
import MpModal, { IBaseModalProps } from '../extends/MpModal';

export interface IPrestationModalProps extends IBaseModalProps {
    prestation: Prestation | null;
    baseName?: string;
    baseCategory?: Category;
    onCreate?: (prestation: Prestation) => void;
}

export interface IPrestationModalState {
    name: string;
    category: Category | null;
    loading: boolean;
    error: string;
}

export default class PrestationModal extends Component<IPrestationModalProps, IPrestationModalState> {
    inputRef: React.RefObject<HTMLInputElement>;
    categoryList: PerfectAJOList<Category>;

    constructor(props: IPrestationModalProps) {
        super(props);

        this.state = this.initState();
        this.inputRef = createRef();

        this.categoryList = new PerfectAJOList('/category/list', () => {
            return {};
        });
    }

    initState() {
        const p: IPrestationModalState = {
            name: this.props.prestation?.name.get() ?? this.props.baseName ?? '',
            category: this.props.prestation?.category.get() ?? this.props.baseCategory ?? null,
            loading: false,
            error: '',
        };
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<IPrestationModalProps>,
        prevState: Readonly<IPrestationModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
        if (prevProps.open !== this.props.open && this.props.open) {
            setTimeout(() => {
                this.inputRef.current?.focus();
            });
        }
    }

    addPrestation() {
        const { loading, name } = this.state;
        const { prestation } = this.props;
        this.setState({
            loading: true,
            error: '',
        });
        let params: any;
        let url: string;
        if (prestation === null) {
            url = '/prestation/update';
            params = {
                name: name,
                category: {
                    id: this.state.category?.getAjoIdentifier(),
                },
            };
        } else {
            url = '/prestation/update';
            params = {
                id: prestation.getAjoIdentifier(),
                name: name,
                category: {
                    id: this.state.category?.getAjoIdentifier(),
                },
            };
        }
        if (prestation !== null) {
            params['id'] = prestation.getAjoIdentifier();
        }
        post(url, params).then((res: any) => {
            this.setState({
                loading: false,
            });
            if (Result.isSuccess(res)) {
                Result.applyResult(res, AppManager.updater(), true);

                const p = Prestation.build();
                Result.applyResult(res, p, true);

                this.props.onClose();
                if (prestation === null) {
                    AppManager.addToast(new Toast('La prestation a été ajoutée avec succès.', 'success'));
                } else {
                    AppManager.addToast(new Toast('La prestation a été modifiée avec succès.', 'success'));
                }
                this.props.onCreate?.(p);
            } else {
                this.setState({
                    error: getErrorMessage(Result.getErrorStr(res)),
                });
            }
        });
    }

    render(): JSXInternal.Element {
        const { open, prestation, onClose } = this.props;
        const { loading, name, error } = this.state;

        if (open) {
            this.categoryList.need();
        }

        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.addPrestation();
                }}
                title={prestation === null ? 'Ajouter une prestation' : 'Modifier une prestation'}
                done={prestation === null ? 'Ajouter' : 'Modifier'}
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <Box className="flex flex-col !text-gray-600 gap-2">
                        <Typography className="!text-sm !font-semibold">NOM DE LA PRESTATION</Typography>
                        <TextField
                            inputProps={{
                                ref: this.inputRef,
                            }}
                            fullWidth
                            value={name}
                            onChange={(e) => {
                                this.setState({ name: (e.target as any).value });
                            }}
                            placeholder="Nom de la prestation"
                            variant="outlined"
                        />

                        <Typography className="!text-sm !font-semibold">CATÉGORIE DE LA PRESTATION</Typography>
                        <SelectCategoryList
                            list={this.categoryList.getList()}
                            single={true}
                            selectList={this.state.category === null ? [] : [this.state.category]}
                            onSelectList={(list) => {
                                if (list.length > 0) {
                                    this.setState({
                                        category: list[0],
                                    });
                                } else {
                                    this.setState({
                                        category: null,
                                    });
                                }
                            }}
                        />

                        {error !== '' && (
                            <Typography
                                component={'p'}
                                className="!text-sm text-red-600 !mt-1 !mb-1 !font-medium text-center"
                            >
                                {error}
                            </Typography>
                        )}
                    </Box>
                )}
            </MpModal>
        );
    }
}
